import { RoomCount } from '@/entities/map'
import { useMultiScrollState } from '@/shared/lib'

import { FilterChip } from './filter-chip'
import { Filter, useFilter } from '../../model/filter'

const ROOM_COUNTS = [
  {
    title: '1개',
    value: RoomCount.One,
  },
  {
    title: '2개',
    value: RoomCount.Two,
  },
  {
    title: '3개 이상',
    value: RoomCount.ThreePlus,
  },
]

export const RoomCounts = () => {
  const { registerScrollElement } = useMultiScrollState<HTMLDivElement>()

  const {
    filter: { roomCounts },
    updateFilter,
  } = useFilter()

  const handleRoomCountChange = (value: RoomCount) => () => {
    updateFilter({ roomCounts: value })
  }

  return (
    <div
      className="p-6 pt-0 pr-4"
      ref={element => {
        if (element) {
          registerScrollElement(Filter.RoomCounts, element)
        }
      }}
    >
      <h3 className="typo-body1 mb-3 font-semibold text-black">방 개수</h3>
      <ul className="flex flex-wrap gap-2">
        {ROOM_COUNTS.map(({ title, value }) => (
          <li key={value}>
            <FilterChip
              selected={roomCounts.includes(value)}
              onClick={handleRoomCountChange(value)}
            >
              {title}
            </FilterChip>
          </li>
        ))}
      </ul>
    </div>
  )
}
